module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topnav', {
    attrs: {
      "toptype": _vm.toptype
    },
    on: {
      "navtype": _vm.navtype
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "600px"
    }
  }, [(_vm.configs) ? _c('div', {
    staticClass: "block"
  }, [_c('el-image', {
    staticStyle: {
      "width": "100%",
      "height": "500px",
      "display": "block"
    },
    attrs: {
      "src": _vm._f("addurl")(_vm.configs.shouye_pic)
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "response bg-gray"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "altas",
    staticClass: "server-group  marginauto flex align-center flex-wrap",
    staticStyle: {
      "width": "1325px"
    }
  }, [_vm._l((_vm.tlist), function(item, index) {
    return [_c('div', {
      staticClass: "serviceone pointer animated bounceInLeft slow hvr-glow ttttt",
      on: {
        "click": function($event) {
          return _vm.tonext(item.path)
        }
      }
    }, [_c('div', {
      staticClass: "flex justify-between align-center stop"
    }, [_c('el-image', {
      staticClass: "simg",
      attrs: {
        "src": item.image,
        "fit": "fill"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "scon"
    }, [_c('div', {
      staticClass: "stitle"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "sinfo"
    }, [_vm._v(_vm._s(item.english))])]), _vm._v(" "), _vm._m(1, true)], 1), _vm._v(" "), (index == 3) ? _c('div', {
      staticClass: "sbot flex justify-start align-center flex-wrap"
    }, _vm._l((item.list), function(items, indexs) {
      return _c('div', {
        key: indexs,
        staticClass: "botlist text-cut"
      }, [_vm._v(_vm._s(items.title))])
    }), 0) : _c('div', {
      staticClass: "sbot flex justify-start align-center flex-wrap"
    }, _vm._l((item.list), function(items, indexs) {
      return _c('div', {
        key: indexs,
        staticClass: "botlist text-cut"
      }, [_vm._v(_vm._s(items.name ? items.name : items.shop_name))])
    }), 0)])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "marginauto",
    staticStyle: {
      "width": "1325px",
      "padding": "60px 0 38px 0"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    ref: "qyrz",
    staticClass: "response flex justify-start align-start",
    staticStyle: {
      "margin-bottom": "70px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-image', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.qyrzshow),
      expression: "qyrzshow"
    }],
    staticClass: " animated flipInX slow",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "src": "/static/assets/images/index/img4.png",
      "fit": "fill"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#a7a7a7",
      "font-size": "18px",
      "line-height": "28px",
      "min-height": "200px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.configs.qyrz_intro ? _vm.configs.qyrz_intro : '') + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "cbtn pointer",
    on: {
      "click": _vm.toapply
    }
  }, [_vm._v("\n                            立即申请\n                        ")])])], 1), _vm._v(" "), _c('div', {
    ref: "lease",
    staticClass: "flex justify-start align-center response"
  }, _vm._l((_vm.lease_list), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.leaseshow),
        expression: "leaseshow"
      }],
      key: index,
      staticClass: "cone animated zoomIn slow pointer hvr-glow",
      on: {
        "click": function($event) {
          return _vm.toroomdetail(item.id)
        }
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "100%",
        "height": "205px"
      },
      attrs: {
        "src": _vm._f("addurl")(item.image),
        "fit": "fill"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "20px 28px"
      }
    }, [_c('div', {
      staticClass: "flex justify-start align-center"
    }, [_c('div', {
      staticClass: "colortwo"
    }, [_vm._v("房间号：")]), _vm._v(" "), _c('div', {
      staticClass: "colorone"
    }, [_vm._v(_vm._s(item.number))])]), _vm._v(" "), _c('div', {
      staticClass: "flex justify-start align-center",
      staticStyle: {
        "margin": "20px 0"
      }
    }, [_c('div', {
      staticClass: "colortwo"
    }, [_vm._v("位 置：")]), _vm._v(" "), _c('div', {
      staticClass: "colorone"
    }, [_vm._v(_vm._s(item.position) + "楼")])]), _vm._v(" "), _c('div', {
      staticClass: "flex justify-start align-center"
    }, [_c('div', {
      staticClass: "colortwo"
    }, [_vm._v("工位数：")]), _vm._v(" "), _c('div', {
      staticClass: "colorone"
    }, [_vm._v(_vm._s(item.work))])])]), _vm._v(" "), _c('div', {
      staticClass: "csbtn text-center",
      on: {
        "click": function($event) {
          return _vm.shownow(item.id)
        }
      }
    }, [_vm._v("\n                            立即咨询\n                        ")])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "response flex justify-center"
  }, [_c('div', {
    staticClass: "tomore pointer hvr-wobble-horizontal",
    on: {
      "click": function($event) {
        return _vm.tonext('/tenancy')
      }
    }
  }, [_vm._v("\n                        查看更多\n                    ")])])]), _vm._v(" "), _c('div', {
    ref: "article",
    staticClass: "response bgblue"
  }, [_c('div', {
    staticClass: "marginauto",
    staticStyle: {
      "width": "1325px",
      "padding": "100px 0"
    }
  }, [_c('div', {
    staticClass: "flex  align-center",
    staticStyle: {
      "margin-bottom": "70px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "flex-end"
    }
  }, [(_vm.tabindex == 0) ? _c('div', {
    staticClass: "text-white",
    staticStyle: {
      "font-size": "55px",
      "font-weight": "600"
    }
  }, [_vm._v("政府通告")]) : _vm._e(), _vm._v(" "), (_vm.tabindex == 1) ? _c('div', {
    staticClass: "text-white",
    staticStyle: {
      "font-size": "55px",
      "font-weight": "600"
    }
  }, [_vm._v("通知资讯")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "30px",
      "margin-bottom": "5px"
    }
  }, [_c('div', {
    staticClass: "geng",
    on: {
      "click": _vm.liadetail
    }
  }, [_vm._v("了解更多->\n\t\t\t\t\t\t   \t"), _c('div', {
    staticClass: "yin"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center align-center",
    staticStyle: {
      "margin-left": "80px"
    }
  }, [_c('div', {
    staticClass: "tabone pointer",
    class: _vm.tabindex == 0 ? 'tabactive' : '',
    on: {
      "click": function($event) {
        return _vm.tabchange(0)
      }
    }
  }, [_vm._v("\n                                政府通告\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "tabone pointer",
    class: _vm.tabindex == 1 ? 'tabactive' : '',
    on: {
      "click": function($event) {
        return _vm.tabchange(1)
      }
    }
  }, [_vm._v("\n                                通知资讯\n                            ")])])]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleshow),
      expression: "articleshow"
    }],
    staticClass: "slideInRight animated",
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 9
    }
  }, [(_vm.articlelist.length) ? _c('div', {
    staticClass: "leftblock pointer",
    on: {
      "click": function($event) {
        return _vm.topdetail(_vm.articlelist[0].id, _vm.tabindex)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "30px",
      "color": "#64f2ff",
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.articlelist[0].release_time ? _vm.articlelist[0].release_time : _vm.articlelist[0].date))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "85px",
      "color": "#64f2ff",
      "font-size": "22px"
    }
  }, [_vm._v(_vm._s(_vm.articlelist[0].title))]), _vm._v(" "), _c('div', {
    staticClass: "text-white text-cut4",
    staticStyle: {
      "font-size": "18px",
      "line-height": "36px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.articlelist[0].content)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    class: _vm.showan ? 'slideInRight animated' : '',
    attrs: {
      "span": 14
    }
  }, _vm._l((_vm.articlelist), function(item, index) {
    return (index < 4) ? _c('div', {
      key: index,
      staticClass: "newsone pointer",
      on: {
        "click": function($event) {
          return _vm.topdetail(item.id, _vm.tabindex)
        }
      }
    }, [_c('div', {}, [_c('div', {
      staticClass: "ntop flex justify-between align-end"
    }, [_c('div', {
      staticClass: "flex justify-start align-center"
    }, [_c('div', {
      staticClass: "text-cut",
      staticStyle: {
        "color": "#64f2ff",
        "margin-right": "10px",
        "max-width": "500px"
      }
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticStyle: {
        "color": "#64f2ff",
        "margin-right": "50px"
      }
    }, [_vm._v("\n                                                " + _vm._s(item.release_time ? item.release_time : item.date) + "\n                                            ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#64f2ff",
        "font-size": "16px"
      }
    }, [_vm._v("\n                                                详情 →\n                                            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "response",
      staticStyle: {
        "background-color": "#64f2ff",
        "height": "3px",
        "margin-top": "15px"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-white text-cut2",
      staticStyle: {
        "font-size": "18px",
        "line-height": "32px",
        "margin-top": "10px",
        "min-height": "64px"
      }
    }, [_vm._v(" " + _vm._s(item.content) + "\n                                    ")])])]) : _vm._e()
  }), 0)], 1)], 1)]), _vm._v(" "), _c('div', {
    ref: "partner",
    staticClass: "response bg-gray"
  }, [_c('div', {
    staticClass: "marginauto",
    staticStyle: {
      "width": "1325px"
    }
  }, [_vm._m(3), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, _vm._l((_vm.partner_list), function(item, index) {
    return _c('el-col', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.partnershow),
        expression: "partnershow"
      }],
      key: index,
      staticClass: "animated jackInTheBox",
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "flex justify-center flex-direction pointer"
    }, [_c('div', {
      staticClass: "marginauto bg-white flex justify-center hvr-wobble-skew",
      staticStyle: {
        "width": "290px",
        "height": "70px",
        "overflow": "hidden",
        "border-radius": "6px"
      },
      on: {
        "click": function($event) {
          return _vm.toout(item.href)
        }
      }
    }, [_c('el-image', {
      staticStyle: {
        "height": "70px"
      },
      attrs: {
        "src": _vm._f("addurl")(item.image),
        "fit": "fill"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "text-center text-cut",
      staticStyle: {
        "font-size": "20px",
        "color": "#929191",
        "margin-top": "24px",
        "margin-bottom": "70px"
      }
    }, [_vm._v(_vm._s(item.name))])])])
  }), 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "咨询",
      "visible": _vm.addcompany
    },
    on: {
      "update:visible": function($event) {
        _vm.addcompany = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "60%",
      "margin": "0 auto"
    }
  }, [_c('el-form', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "model": _vm.cominfo
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.name),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "name", $$v)
      },
      expression: "cominfo.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.phone),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "phone", $$v)
      },
      expression: "cominfo.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "咨询内容",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入咨询内容",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.content),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "content", $$v)
      },
      expression: "cominfo.content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center align-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.nowdisabled,
      "type": "primary"
    },
    on: {
      "click": _vm.tosub
    }
  }, [_vm._v("提 交")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex justify-center align-center flex-direction"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("精选创业服务")]), _vm._v(" "), _c('div', {
    staticClass: "titleline"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "el-icon-arrow-right rightarrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex justify-center align-center flex-direction"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("企业入驻")]), _vm._v(" "), _c('div', {
    staticClass: "titleline"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex justify-center align-center flex-direction"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("合作伙伴")]), _vm._v(" "), _c('div', {
    staticClass: "titleline"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-198605e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 384
// module chunks = 1